import { setMeta, checkRule } from '@/router/middleware'
import routerView from '@/views/publishers/routerView'


const StoresList = () => import ('@/views/publishers/StoresList')
const List = () => import ('@/views/publishers/List')
const Profile = () => import('@/views/publishers/Profile')

export default {
    path: 'publishers',
    redirect: 'publishers',
    component: routerView,
    children: [
        {
            path: 'store',
            name: 'publishers.stores',
            component: StoresList,
            meta: {
                labelTrans: 'publisher.select_store',
                middleware: [setMeta, checkRule],
                rules: {
                    publisher: ['read_any', 'read_group', 'read_own']
                }
            }
        },
        {
            path: ':store_id?',
            name: 'publishers.list',
            component: List,
            meta: {
                labelTrans: 'publisher.plural',
                middleware: [setMeta, checkRule],
                rules: {
                    publisher: ['read_any', 'read_group', 'read_own']
                }
            }
        },
        {
            path: 'rel/:id',
            name: 'publishers.profile',
            component: Profile,
            meta: {
                labelTrans: 'publisher.profile',
                middleware: [setMeta, checkRule],
                rules: {
                    publisher: ['read_any', 'read_group', 'read_own']
                }
            }
        }
    ]
}